import React, { useState, useEffect } from 'react';
import * as MaterialUi from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useForm } from "react-hook-form";
import * as InitMapStore from '../../../../../redux/store/init-map/init-map.store';
import * as InitmapConfig from '../../../config/config';
import { WmsBaseLink, APIUrlDefault } from '../../../../../utils/configuration';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    DialogActions,
    Button,
    TextField,
    DialogContent,
    DialogTitle,
    Dialog,
    makeStyles,
    Typography,
    IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import FileManagement from "../../../../../components/file_management/file_management";

let GlobalIdSetTimeOut = null

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function SettingFileLayer(props) {
    const classes = useStyles();

    const [files, setFiles] = useState([]);
    const [filesTemp, setFilesTemp] = useState([]);
    const [isShow, setShow] = useState(false);

    const { register } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    useEffect(() => {
        console.log('props.data?.documentFiles', props.data?.documentFiles)
        setFiles(props.data.documentFiles);
    }, [])

    useEffect(() => {
        if (files && files.length > 0) {
            props.setData({
                ...props.data,
                documents: files.map(item => item.fileId)
            });
        }
    }, [files])

    const onOpenSelectFile = () => {
        setShow(true);
        setFilesTemp(files);
    };

    const onCloseSelectFile = () => {
        setShow(false);
        setFiles(filesTemp);
    };

    const onSaveSelectFile = () => {
        setShow(false);
    };

    const onChangeFile = (newfiles) => {
        console.log('jhsdgfksdf', files, newfiles)
        console.log('fkshhgjdfhkgjhfdl;g', uniqueArray(files, newfiles))
        setFiles(uniqueArray(files, newfiles))
    }

    const uniqueArray = (array1, array2) => {
        if (!array1 || array1.length == 0) return array2
        else if (!array2 || array2.length == 0) return array1
        else {
            const mergedArray = array1.concat(array2);
            console.log('mergedArray', mergedArray)
            const uniqueArray = mergedArray.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.fileId === item.fileId)
            );
            return uniqueArray
        }
    }

    const onRemoveFile = (id) => {
        setFiles(files.filter(x => x.fileId != id))
    }

    return (
        <div className='change-layer-data-source container-fluid'>
            <div className="col-12">
                <label className="text-dark">
                    File thuyết minh
                </label>
                {!isShow && files && files.length > 0 && files.map(item => (
                    <div className='position-relative mb-3' key={item.fileId}>
                        <strong>{item.fileName}</strong>
                        <span onClick={() => onRemoveFile(item.fileId)} className='close_btn'>x</span>
                    </div>
                ))
                }
                <div>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onOpenSelectFile}
                    >
                        Chọn file
                    </Button>
                </div>
            </div>

            {
                isShow && (
                    <Dialog
                        onClose={onCloseSelectFile}
                        open={isShow}
                        fullWidth={true}
                        maxWidth="md"
                        className="dialog-preview-form"
                    >
                        <DialogTitle disableTypography>
                            <Typography component={'span'} variant="h6">Quản lý file</Typography>
                            <IconButton
                                aria-label="close"
                                className={classes.closeButton}
                                onClick={onCloseSelectFile}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <FileManagement
                                files={files}
                                multiple={true}
                                setFiles={onChangeFile}
                                acceptedFiles={["doc", "docx", "pdf"]}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button
                                type="button"
                                onClick={onCloseSelectFile}
                                variant="contained"
                                startIcon={<CloseIcon />}
                            >
                                Hủy
                            </Button>
                            {files && files.length > 0 && (
                                <Button
                                    type="button"
                                    color="primary"
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={onSaveSelectFile}
                                >
                                    Lưu
                                </Button>
                            )}
                        </DialogActions>
                    </Dialog>
                )
            }
        </div>
    )
}

const mapStateToProps = state => ({
    //listDataSource: state.initMap.arrayDataSource
})

const mapDispatchToProps = dispatch => bindActionCreators({
    //GetListDataSource: InitMapStore.GetListDataSource
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SettingFileLayer)